import React, { useState } from 'react';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
import { Link } from 'react-router-dom';
import { H6, Btn } from '../../../AbstractElements';
import { pinagareAPIURL } from '../../../Constant';
import prog_application_form from "../../../assets/downloads/manual_application_form.pdf"

const DropdownCommon = ({ dropdownMain, icon = true, iconName, btn, options, eng, thisToggle, schemeParameters }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen((prevState) => !prevState);

  let searchApplicationToggle, progressStatusToggle, withdrawApplicationToggle, notifyApplicantsToggle, boardPackToggle, qualifyingMarkToggle, pinagareMeetingToggle, applicationPeriodToggle=null;
  if(thisToggle==null||thisToggle==undefined){
    progressStatusToggle=()=>{};
    notifyApplicantsToggle=()=>{};
    boardPackToggle=()=>{};
    qualifyingMarkToggle=()=>{};
    pinagareMeetingToggle=()=>{};
    applicationPeriodToggle=()=>{};
    withdrawApplicationToggle=()=>{};
    searchApplicationToggle=()=>{};
  }
  else{
    progressStatusToggle=thisToggle.progressStatusToggle;
    notifyApplicantsToggle=thisToggle.notifyApplicantsToggle;
    boardPackToggle=thisToggle.boardPackToggle;
    qualifyingMarkToggle=thisToggle.qualifyingMarkToggle;
    pinagareMeetingToggle=thisToggle.pinagareMeetingToggle;
    applicationPeriodToggle=thisToggle.applicationPeriodToggle;
    withdrawApplicationToggle=thisToggle.withdrawApplicationToggle;
    searchApplicationToggle=thisToggle.searchApplicationToggle;
  }

  return (
    <Dropdown {...dropdownMain} isOpen={dropdownOpen} toggle={toggle} style={{width:'190px'}} >
      <DropdownToggle {...btn} style={{width:'190px'}}>
        {icon && <i className={iconName}></i>}
        {!icon && options[0]}
      </DropdownToggle>
      <DropdownMenu style={{width:'190px'}}>
        {options.map((item, i) => (
          <DropdownItem key={i}>
            {i==1&&eng=="secretariat"?(<Link to={`${process.env.PUBLIC_URL}/dpsm/scheme/application/ltp/onbehalf`} style={{color:'#000000'}}><b>{item}</b>
          </Link>):(i==4&&eng=="secretariat"?(<div onClick={boardPackToggle} style={{color:'#000000'}}><b>{item}</b>
          </div>):(i==7&&eng=="secretariat"||i==3&&eng=="chairperson"?(
          <div style={{color:'#000000'}}>
            <a href={`${pinagareAPIURL}?generate_pinagare_list_pdf=true&eng=supa_pinagare_evaluation_report&application_details=`+JSON.stringify(schemeParameters)} target="_blank" style={{color:'#000000'}}><b>{item}</b></a>			 
       
          </div>):(
            (i==5&&eng=="secretariat")||(i==2&&eng=="chairperson")?(<div onClick={qualifyingMarkToggle} style={{color:'#000000'}}><b>{item}</b>
            </div>):(
              (i==6&&eng=="secretariat")||(i==1&&eng=="chairperson")?(<div onClick={pinagareMeetingToggle} style={{color:'#000000'}}><b>{item}</b>
              </div>):(
                i==3&&eng=="secretariat"?(<div onClick={applicationPeriodToggle} style={{color:'#000000'}}><b>{item}</b>
                </div>):(
                  i==2&&eng=="secretariat"?(<div onClick={withdrawApplicationToggle} style={{color:'#000000'}}><b>{item}</b>
                  </div>):(
                    i==8&&eng=="secretariat"?(<div onClick={notifyApplicantsToggle} style={{color:'#000000'}}><b>{item}</b>
                    </div>):(
                      i==0?(<div style={{color:'#000000'}}><b>{item}</b>
                      </div>):(
                         i==9&&eng=="secretariat"?(<Link to={prog_application_form} target="_blank" style={{color:'#000000'}}><b>{item}</b>
                         </Link>):(
                          (i==10&&eng=="secretariat")||(i==4&&eng=="chairperson")?(<div onClick={searchApplicationToggle} style={{color:'#000000'}}><b>{item}</b>
                          </div>):(
          <Link to={`${process.env.PUBLIC_URL}/dpsm/home`} style={{color:'#000000'}}><b>{item}</b>
          </Link>)))))))))))}
          
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  );
};

export default DropdownCommon;
